import ICON_REFUND from '@/assets/cs/icon_refund.png';
import ICON_PACKAGE from '@/assets/cs/icon_package.png';
import styled from 'styled-components';
import { useAppDispatch, useAppSelector } from '@/hooks/useReduxHooks';
import { updateCs } from '@/store/modules/cs';

type Props = {
  hasOpenChatAnimation?: boolean;
};

function InquiryButtons({ hasOpenChatAnimation = false }: Props) {
  const dispatch = useAppDispatch();
  const { activeTab, chatType } = useAppSelector((state) => state.cs);

  const onUpdateChatType = (chatType: 'CHAT' | 'REFUND' | 'PACKAGE') => {
    const defaultOptions = {
      chatType,
      isOpenChat: true,
      hasOpenChatAnimation,
    };
    dispatch(
      updateCs(
        activeTab === 'HOME'
          ? {
              ...defaultOptions,
              chatId: null,
              chatList: [],
            }
          : {
              ...defaultOptions,
            },
      ),
    );
  };

  if (chatType !== 'CHAT') {
    return null;
  }

  return (
    <>
      <ButtonWrapper>
        <StyledButton onClick={() => onUpdateChatType('REFUND')}>
          <img src={ICON_REFUND} alt='' width={24} />
          환급건 등록
        </StyledButton>
        <StyledButton onClick={() => onUpdateChatType('PACKAGE')}>
          <img src={ICON_PACKAGE} alt='' width={24} />
          소모품 신청
        </StyledButton>
      </ButtonWrapper>
    </>
  );
}

const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
  margin: 12px;
`;

const StyledButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2px;
  height: 36px;
  padding: 0 10px 0 6px;
  border-radius: 12px;
  border: 1.2px solid #7ca7fa;
  box-shadow: 0px 0px 12px 0px rgba(74, 119, 255, 0.12);
  color: #3a3b3e;
  font-size: 16px;
  font-weight: 600;
  line-height: 150%;
`;

export default InquiryButtons;
